import { apiWrapper } from "@/services/api";
import { getDbsSessionId } from "@/API/dbs/getDbsSessionId";

export const apiWithSessionIdWrapper = async (method, apiName, params = {}) => {
  try {
    const dbsSessionId = await getDbsSessionId();
    // sessionIdの考慮を含めると複雑&予約の期限20min < MJのトークン期限1h で実害はなさそうなので、認証エラー時の再コールはしない
    // よって、第4引数(isNotReCall): true
    return await apiWrapper(method, apiName, params, true, dbsSessionId, "Migrated");
  } catch (err) {
    console.log('ERROR"" apiWithSessionIdWrapper()', err);

    const errorCode = err.response.data.error;
    // セッション切れの場合は、sessionIdを取り直して再実行
    if (errorCode == "dbs601" || errorCode == "dbs602") {
      const newDbSessionId = await getDbsSessionId(true);
      return await apiWrapper(method, apiName, params, true, newDbSessionId, "Migrated");
    } else {
      throw err;
    }
  }
};
